import React from "react"
import { default as Layout } from "../templates/LayoutAuth"

import SegmentLogin from "../large/SegmentLogin"

const Login = props => (
  <Layout>
    <SegmentLogin />
  </Layout>
)

export default Login



// WEBPACK FOOTER //
// ./src/pages/Login.js